import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {getSidebarContent} from "../../Content/actions";
import SectionTitle from '../../Layout/components/SectionTitle';
import SchoolsSearchBar from './SearchBar/SchoolsSearchBar';
import LoadingSpinner from "../../Layout/components/LoadingSpinner";
import ReactHtmlParser from 'react-html-parser';
import HomeSchool from "../../Home/components/HomeSchool";
import {withLocalize} from 'react-localize-redux';
import translations from '../translations/translations_schools_list';

class SchoolsContainer extends Component {
    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    fetchContent() {
        this.props.getSidebarContent('agep_home');
        this.props.getSidebarContent('agep_schools');
    }

    componentDidMount() {
        this.fetchContent();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.languages !== this.props.languages) {
            const {pathname} = this.props.location;
            const expectedUri = this.props.translate('routes.schools');

            if (pathname !== expectedUri) {
                this.props.history.push(expectedUri);
            } else {
                this.fetchContent();
            }
        }
    }

    render() {
        const {sidebar, loading} = this.props;

        if (sidebar.agep_home === null || sidebar.agep_home === undefined || sidebar.agep_schools === null || sidebar.agep_schools === undefined || loading) {
            return (
                <Fragment>
                    <Helmet
                        bodyAttributes={{
                            class: 'schools header-transparent vertical-content-force-height-100'
                        }}
                    />
                    <div className="container">
                        <div className="row mt-0 mb-0 align-items-center" style={{height: '100%'}}>
                            <div className="col-3 mx-auto">
                                <div className="text-center">
                                    <LoadingSpinner/>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            );
        }

        let widgetsHome = sidebar.agep_home.widgets;
        let widgets = sidebar.agep_schools.widgets;

        const pageTitle = this.props.translate('schools_list.page_title') + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE;

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'schools header-transparent'
                    }}
                >
                    <title>{pageTitle}</title>
                </Helmet>
                <div className="container">
                    <SectionTitle cssClass="mt-lg-130 mt-md-130"
                                  title={<Fragment>{ReactHtmlParser(widgets.titre.data.content)}</Fragment>}
                                  subtitle={widgetsHome.sous_titre.data.content}
                    />

                    <SchoolsSearchBar />

                    <HomeSchool widgets={widgetsHome} showButton={false}/>
                </div>
            </Fragment>
        );
    }
}

SchoolsContainer.propTypes = {
    getSidebarContent: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    sidebar: state.content.sidebar,
    loading: state.content.sidebarLoading,
    errors: state.errors,
    languages: state.localize.languages,
});

export default withRouter(connect(mapStateToProps, {getSidebarContent})(withLocalize(SchoolsContainer)));



// WEBPACK FOOTER //
// ./src/features/Schools/components/SchoolsContainer.js